import type { InsightObjectAttribute } from '@atlassian/jira-servicedesk-insight-object-types/src/common/types/object-attribute.tsx';
import type { OpsgenieTeam } from '@atlassian/jira-servicedesk-insight-object-types/src/common/types/object-details.tsx';
import { AttributeTypeMap } from '@atlassian/jira-servicedesk-insight-shared-types/src/common/types/attribute-types.tsx';
import type { CmdbObjectAttribute } from '@atlassian/jira-servicedesk-insight-shared-types/src/common/types/attribute.tsx';

export const getOpsgenieTeamValuesFromCmdbObjectAttribute = (
	attribute?: CmdbObjectAttribute,
): OpsgenieTeam[] => {
	if (attribute && attribute.type === AttributeTypeMap.OpsgenieTeam) {
		return attribute.objectAttributeValues.map(
			({ opsgenieTeam: { id, name, avatarUrl, url } }) => ({
				id,
				name,
				avatarUrl,
				url,
			}),
		);
	}
	return [];
};

export const getOpsgenieTeamValues = (attribute?: InsightObjectAttribute): OpsgenieTeam[] => {
	if (attribute && attribute.type === 'opsgenieTeam') {
		return attribute.opsgenieTeamTypeValues.map(
			({ opsgenieTeam: { id, name, avatarUrl, url } }) => ({
				id,
				name,
				avatarUrl,
				url,
			}),
		);
	}
	return [];
};
